module.exports = __webpack_public_path__ + "img/media-20.c626c946.png";